import module from 'nominas/sumario/module.js'
import template from './template.html'
import {orderBy} from 'lodash'
import moment from 'moment'

export class NominasSumarioAgregarSeleccionarComponent {
  proyectoId
  nominaId
  regimenFiscalId
  tipoNominaId
  catalogos = {}
  onChange

  seleccionarTipoNomina () {
    this.tipoNominaId = undefined
    this.regimenFiscalId === 9 ? this.tipoNominaId = 0 : angular.noop()
  }

  siguiente () {
    this.onChange({
      $event: {
        detail: {
          proyecto_id: this.proyectoId,
          nomina_id: this.nominaId,
          regimen_fiscal_id: this.regimenFiscalId,
          tipo_nomina_id: this.tipoNominaId,
        },
      },
    })
  }
}

module.component('nominasSumarioAgregarSeleccionar', {
  controller: NominasSumarioAgregarSeleccionarComponent,
  template,
  bindings: {
    proyectoId: '<',
    nominaId: '<',
    regimenFiscalId: '<',
    tipoNominaId: '<',
    catalogos: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/sumario/components/agregar/seleccionar/component.js